const isNil = (value) => value === null || value === undefined;

export const formatSchedule = (record) => {
  if (record.schedule !== 'daily' || isNil(record.run_after_utc_hour)) return record.schedule || '';
  return `daily after ${String(record.run_after_utc_hour).padStart(2, '0')}:00 UTC`;
};

export const formatWindow = (record) => {
  if (record.snapshot) return 'snapshot';
  return isNil(record.window_days) ? '' : `${record.window_days} days`;
};

export const formatCreated = (record) => {
  const date = record.created_at
    ? new Date(record.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
    : '';
  return `${record.created_by || '–'}, ${date}`;
};

export const formatDateTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
};

export const formatCreatedDate = (value) =>
  value ? new Date(value).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
